import { isAxiosError } from "axios";
import { apiErrorMessage, loggableRequestError } from "./apiErrorMessage.ts";

/** Shown when the number entered to change to is the one already on the account. */
export const ALREADY_YOUR_NUMBER = "That's already your number.";

/**
 * The message for a refused send, verify, or resend while changing the account's
 * phone number from Settings. The server's own text for a taken number is
 * written for onboarding, so Settings says it its own way; a rate limit's text
 * names the wait, which "try again" would only spend.
 *
 * @param fallback - What to say for any other failure, worded for the step.
 */
export const changePhoneErrorMessage = (error: unknown, fallback: string): string => {
  const code = isAxiosError(error) ? error.response?.data?.code : undefined;
  if (code === "PHONE_ALREADY_TAKEN") return "That number belongs to another okthx account.";
  if (code === "TOO_MANY_SENDS" || code === "TOO_MANY_ATTEMPTS") {
    return apiErrorMessage(error) ?? fallback;
  }
  return fallback;
};

/**
 * {@link changePhoneErrorMessage}, logged first when the step did not merely
 * refuse. A 4xx is a refusal the message explains; anything else never judged
 * the request and is logged, though never the error itself: a verify's request
 * body is the code just typed.
 */
export const changePhoneFailureMessage = (error: unknown, fallback: string): string => {
  const status = isAxiosError(error) ? error.response?.status : undefined;
  if (status === undefined || status >= 500) {
    console.error("Phone number change failed:", loggableRequestError(error));
  }
  return changePhoneErrorMessage(error, fallback);
};
